import { type FC } from "react";

import { BaseDatePicker, type BaseDatePickerProps } from "./BaseDatePicker";
import { BaseDateRangePicker, type BaseDateRangePickerProps } from "./BaseDateRangePicker";

export type DatePickerProps = BaseDatePickerProps & { ranged?: false };
export type DateRangePickerProps = BaseDateRangePickerProps & { ranged: true };

export const DatePicker: FC<DatePickerProps | DateRangePickerProps> = (props) => {
	if (props.ranged === true) {
		return <BaseDateRangePicker {...props} />;
	}

	return <BaseDatePicker {...props} />;
};
